import * as yup from 'common/yup';
import {enumType} from '../common/enumType';

export const HashAlgorithm = enumType({
   MD5: 'MD5',
   RIPEMD160: 'RIPEMD-160',
   SHA1: 'SHA-1',
   SHA224: 'SHA-224',
   SHA256: 'SHA-256',
   SHA384: 'SHA-384',
   SHA512: 'SHA-512',
});

export const HashAlgorithmSchema = yup.string().oneOf(HashAlgorithm.keys);
